import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CloudHelpService {
  helpPanelDispalyStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() { }
}
